// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1yJDe","author":"Table_author__1RvT9","authorImage":"Table_authorImage__LSipo","unreadRow":"Table_unreadRow__X8j2Y"};